import SBottomTip from './style.module.scss';

const BottomTip = ({ config }) => {
  return (
    <div className={SBottomTip['tip-wrapper']}>
      <div className={SBottomTip['tip-hint']}>{config.hint}</div>
      <div className={SBottomTip['tip-highlight']}>{config.highlight}</div>
    </div>
  );
};

export default BottomTip;
